





import Vue from 'vue';

export default Vue.extend({
  name: 'Alert',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'top',
    }
  },
  computed: {},
});
